class VeluxoCatalogSearch extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    this.input = this.querySelector('input[type="search"]');
    this.panel = this.querySelector('.vx-compact-panel');
    this.results = this.querySelector('[data-results]');
    this.active = false;
    this.pointerInside = false;
    this.close();
    this.input.addEventListener('click', () => {this.active = true;this.search();}, options);
    this.input.addEventListener('input', () => {this.active = true;this.schedule();}, options);
    this.addEventListener('keydown', event => {
      if(event.key === 'Escape'){event.preventDefault();this.close();}
      if(event.target === this.input && event.key === 'ArrowDown' && !this.panel.hidden){event.preventDefault();this.results.querySelector('a')?.focus();}
    }, options);
    // Taps inside the panel (iPhone/iPad Safari do not focus links on tap) must not close it before the link opens.
    this.addEventListener('pointerdown', () => {this.pointerInside = true;}, options);
    document.addEventListener('pointerup', () => setTimeout(() => {this.pointerInside = false;}, 400), options);
    document.addEventListener('pointercancel', () => {this.pointerInside = false;}, options);
    this.addEventListener('focusout', event => {
      if(this.pointerInside) return;
      if(event.relatedTarget && this.contains(event.relatedTarget)) return;
      setTimeout(() => {if(!this.pointerInside && !this.contains(document.activeElement))this.close();}, 150);
    }, options);
    document.addEventListener('pointerdown', event => {if(!this.contains(event.target))this.close();}, options);
    window.addEventListener('pageshow', () => this.close(), options);
    this.querySelector('form').addEventListener('submit', () => this.close(), options);
  }
  close() {
    this.active = false;
    clearTimeout(this.timer);
    this.request?.abort();
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded','false');
  }
  schedule() {
    clearTimeout(this.timer);
    this.request?.abort();
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded','false');
    this.timer = setTimeout(() => this.search(),180);
  }
  async search() {
    const query = this.input.value.trim();
    if(!this.active || !query){this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');return;}
    this.request?.abort();
    const request = this.request = new AbortController();
    const url = new URL(this.dataset.endpoint,location.origin);
    url.searchParams.set('q',query);
    url.searchParams.set('resources[type]','product');
    url.searchParams.set('resources[limit]','6');
    url.searchParams.set('section_id','veluxo-search-suggestions');
    try {
      const response = await fetch(url,{signal:request.signal});
      if(!response.ok) return;
      const html = await response.text();
      if(request.signal.aborted || !this.active || query !== this.input.value.trim() || !this.isConnected)return;
      const list = new DOMParser().parseFromString(html,'text/html').querySelector('[data-vx-suggestions]');
      if(!list)return;
      this.results.replaceChildren(list);
      this.panel.hidden=false;
      this.input.setAttribute('aria-expanded','true');
    } catch(error) {
      if(error.name !== 'AbortError'){this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');}
    }
  }
  disconnectedCallback(){this.close();this.controller?.abort();}
}
if(!customElements.get('veluxo-catalog-search'))customElements.define('veluxo-catalog-search',VeluxoCatalogSearch);
